import getTypeof from './get-typeof.helper';
import isNullish from './is-nullish.helper';

type EmptyObjectLike<T = unknown> = Record<string, T>;
type Constructor = new () => unknown;
type EmptyValidator = (value: unknown) => boolean;

const isEmpty = <T = unknown>(input: EmptyObjectLike<T> | Constructor | T[] | T | string | null | undefined) => {
  if (isNullish(input)) {
    return true;
  }
  const type = getTypeof(input);
  return !!switchValidator[type]?.(input);
};

export const isArrayEmpty = <T extends []>(input: T): boolean => input.length === 0;

export const isObjectEmpty = <T = unknown>(input: EmptyObjectLike<T> | Constructor): boolean =>
  Object.keys(input).length === 0 && Object.getPrototypeOf(input) === Object.prototype;

export const isStringEmpty = (input: string) => input.trim() === '';

const switchValidator: Record<string, EmptyValidator> = {
  array: isArrayEmpty as EmptyValidator,
  map: isObjectEmpty as EmptyValidator,
  number: () => false,
  object: isObjectEmpty as EmptyValidator,
  set: isObjectEmpty as EmptyValidator,
  string: isStringEmpty as EmptyValidator,
};

export default isEmpty;
